import { gql } from '@apollo/client';

export const GetChatsQuery = gql`
    query GetChats($chatId: ID, $type: ChatType, $entityId: ID, $ownerId: ID) {
        getChats(chatId: $chatId, type: $type, entityId: $entityId, ownerId: $ownerId) {
            id
            participants {
                id
                fullName
                roles
                student {
                    id
                    fullName
                }
                school {
                    id
                    shortName
                }
            }
            messages {
                id
                message
                sender {
                    id
                    fullName
                    roles
                    school {
                        id
                        fullName
                    }
                    student {
                        id
                        fullName
                    }
                }
                viewed
                createdAt
                updatedAt
            }
            owner {
                id
                fullName
                roles
            }
            type
            status
            createdAt
            updatedAt
        }
    }
`;
